import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AboutComponent} from './about/about.component';
import {HomeComponent} from './home/home.component';
import {LocationComponent} from './location/location.component';
import {ServicesComponent} from './services/services.component';
import {ProductsComponent} from './products/products.component';
import {ProductsKaivuriComponent} from './products/products-kaivuri/products-kaivuri.component';
import {ProductsVesakkoComponent} from './products/products-vesakko/products-vesakko.component';
import {ProductsErikoisComponent} from './products/products-erikois/products-erikois.component';

const routes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'about', component: AboutComponent},
    {path: 'services', component: ServicesComponent},
    {
        path: 'products',
        children: [
            { path: '', component: ProductsComponent, pathMatch: 'full'},
            {path: 'excavators', component: ProductsKaivuriComponent},
            {path: 'mulchers', component: ProductsVesakkoComponent},
            {path: 'special', component: ProductsErikoisComponent}
        ]
    },
    {path: 'location', component: LocationComponent}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        onSameUrlNavigation: 'reload',
        useHash: true
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
